// When changing these values, make sure that you also update them in maistra-booking-proxy and vice versa
export const MAX_NIGHTS = 90
export const MAX_ADULTS = 18
export const MAX_CHILDREN = 21
export const MAX_GUESTS = 24
export const MAX_CHILD_AGE = 17
